module.exports = __webpack_public_path__ + "img/andrew.bed4e07b.png";